/**
 * System Configuration DTOs
 * Expiration threshold settings per clinical entity type
 */

export interface ExpirationThresholds {
  warnRedDays: number;
  warnOrangeDays: number;
  warnYellowDays: number;
}

export interface MedicationsConfig extends ExpirationThresholds {
  defaultExpiryDays: number;
}

export interface SystemConfigData {
  tenantId: string;
  medications: MedicationsConfig;
  priorAuthorization: ExpirationThresholds;
  pocCertifications: ExpirationThresholds;
  providerAssignments: ExpirationThresholds;
  updatedAt: string | null;
  updatedBy: string | null;
}

export interface UpdateSystemConfigRequest {
  medications: MedicationsConfig;
  priorAuthorization: ExpirationThresholds;
  pocCertifications: ExpirationThresholds;
  providerAssignments: ExpirationThresholds;
}

export const SYSTEM_CONFIG_DEFAULTS: UpdateSystemConfigRequest = {
  medications:         { defaultExpiryDays: 30, warnRedDays: 7,  warnOrangeDays: 14, warnYellowDays: 30 },
  priorAuthorization:  { warnRedDays: 14, warnOrangeDays: 30, warnYellowDays: 45 },
  pocCertifications:   { warnRedDays: 14, warnOrangeDays: 30, warnYellowDays: 45 },
  providerAssignments: { warnRedDays: 7,  warnOrangeDays: 14, warnYellowDays: 30 },
};
